var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datetime)?_c('div',{staticClass:"ml-4 pl-2 pb-4"},[_c('span',{staticClass:"greyDarken1--text"},[_vm._v("\n    "+_vm._s(_vm.momentTz
    .tz(_vm.datetime, _vm.timezone)
    .clone()
    .tz(_vm.momentTz.tz.guess(true))
    .format('YYYY-MM-DD HH:mm:ss z'))+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }